import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { NavService } from '../../../../services/nav.service';
import { PermissionService } from 'src/app/shared/services/permission-service.service';
import { AgentWidgetService } from 'src/app/shared/services/agent-widget.service';
import { AuthService } from 'src/app/auth/services/auth.service';

@Component({
  selector: 'app-change-company',
  templateUrl: './change_company.component.html',
  styleUrls: ['./change_company.component.scss']
})
export class ChangeCompanyComponent implements OnInit {
  content = environment.content;
  public companyChange: boolean = false;
  public Company: any[] = []
  public selectedCompany: any = {};
  public displayDropdowns: boolean = false;

  constructor(
    public navServices: NavService, 
    private permissionService: PermissionService,
    private agentWidgetService: AgentWidgetService,
    private authService: AuthService
  ) { }

  async ngOnInit() {
    this.Company = JSON.parse(localStorage.getItem("Applications") || '[]')
    const currentCompany = localStorage.getItem('currentCompany') || 'unity';
    this.selectedCompany = this.Company.find(app => app.name !== currentCompany) || null;
    this.displayDropdowns = this.Company.length > 1;
    await this.Company.map(val => {
      if (val.name == "unity") {
        val.imgIcon = this.content?.companyLogoIcons?.unityIcon;
      } else {
        val.imgIcon = this.content?.companyLogoIcons?.mingleIcon;
      }
    })
  }

 

  async changeCompany(company) {
    if (!company) return; // Prevent null/undefined company input
    this.selectedCompany = company;
    const companyName = company.name.toLowerCase();

    console.log(`Changing company to: ${companyName} with BaseUrl: ${company.BaseUrl}`);
    await this.authService.switchCompany(company);
    
    // Update permissions
    await this.permissionService.updatePermission();
    
    // Notify Agent Widget about company change before page reloads
    try {
      console.log(`Checking token for ${companyName}`);
      try {
        const companyToken = await this.authService.getCompanyTokens(companyName);

        if (companyToken?.token) {
          console.log(`Found token for ${companyName}`);
          this.agentWidgetService.notifyCompanyChange({
            currentCompany: companyName,
            token: companyToken.token,
            userId: companyToken.userId,
            baseUrl: company.BaseUrl || ''
          });

          console.log(`Sent company change notification for ${companyName}`);
        } else {
          console.error(`Failed to get token for ${companyName} from authService`);
        }
      } catch (tokenError) {
        console.error(`Failed to get ${companyName} token:`, tokenError);
      }
      
      // Small delay to ensure message is sent before reload
      await new Promise(resolve => setTimeout(resolve, 300));
    } catch (error) {
      console.error('Error notifying agent about company change:', error);
      // Continue with reload even if notification fails
    }
    
    // Reload page to apply changes
    window.location.reload();
    console.log(company);
    this.changeClass(company.name);
  }

  changeClass(company) {
    console.log(company);
    const companyNameClass = company?.replace(/\s+/g, '-').toLowerCase();
    const bodyElement = document.body;
    bodyElement.classList.forEach(cls => {
      if (cls.startsWith('company-')) {
        bodyElement.classList.remove(cls);
      }
    });
    if (companyNameClass) {
      bodyElement.classList.add(`company-${companyNameClass}`);
    }
  }

}
